import "bijou/base";

(function ($) {
  $.widget("chopin.disclosures", $.bijou.base, {
    changeText() {
      this.element.find("input").each((_index, input) => {
        const checked = $(input).prop("checked");

        if (checked) {
          this.element.find(`.${input.id}`).show();
        } else {
          this.element.find(`.${input.id}`).hide();
        }
      });
    },
    _create() {
      this._on(this.element.find(".checkbox"), {
        change: this.changeText,
      });

      const selectedInputs = this.element.find("input:checked");
      if (selectedInputs.length === 0) {
        this.element
          .find("#disclosures_Download_the_PDF_documents")
          .prop("checked", true);
      }

      this.changeText();
    },
  });
})(window.jQuery);
